export interface SelectableExerciseGroup {
    label: string;
    value: string;
}
export interface SelectableExercise {
    label: string;
    value: string;
}

export const muscleGroups: SelectableExerciseGroup[] = [
    { value: 'CHEST', label: 'Chest' },
    { value: 'BACK', label: 'Back' },
    { value: 'QUADRICEPS', label: 'Quadriceps' },
    { value: 'TRICEPS', label: 'Triceps' },
    { value: 'GLUTEUS', label: 'Gluteus' },
    { value: 'SHOULDERS', label: 'Shoulders' },
    { value: 'HARMSTRINGS', label: 'Harmstrings' },
    { value: 'BICEPS', label: 'Biceps' },
    { value: 'ABS', label: 'Abs' },
    { value: 'CALVES', label: 'Calves' },
    { value: 'TRAPS', label: 'Traps' },
    { value: 'ADDUCTORS', label: 'Adductors' },
    { value: 'ABDUCTORS', label: 'Abductors' },
    { value: 'NECK', label: 'Neck' },
];